import { Feature, Point } from "geojson";
import mapboxgl from "mapbox-gl";
import { generateSessionId } from "../Manager/EventDetail/utils/generateSessionId";

export type SearchResult = {
  name: string;
  mapbox_id: string;
  feature_type: string;
  address: string;
  full_address: string;
  place_formatted: string;
  coordinates: {
    latitude: number;
    longitude: number;
  };
};

export type SuggestionResult = {
  address: string;
  full_address: string;
  mapbox_id: string;
  name: string;
};

const sessionId = generateSessionId(32);

const BASE_URL = "https://api.mapbox.com/search/searchbox/v1";

export async function searchByName(
  name: string,
  options?: { country?: string }
) {
  const searchParams = new URLSearchParams({
    q: name,
    access_token: mapboxgl.accessToken,
    session_token: sessionId,
    proximity: "ip",
    //types: "poi",
  });
  if (options?.country) {
    searchParams.set("country", options.country);
  }

  return fetch(`${BASE_URL}/suggest?${searchParams.toString()}`, {
    method: "GET",
  }).then(async (results) => {
    try {
      const json = (await results.json()) as {
        suggestions: SuggestionResult[];
      };

      return json.suggestions;
    } catch (e) {
      console.error("[Mapbox]", e);
    }
  });
}

export async function retrieveByMapboxId(mapbox_id: string): Promise<{
  type: "FeatureCollection";
  features: Feature<Point, SearchResult>[];
} | null> {
  const searchParams = new URLSearchParams({
    access_token: mapboxgl.accessToken,
    session_token: sessionId,
  });

  return fetch(
    `${BASE_URL}/retrieve/${mapbox_id}?${searchParams.toString()}`
  ).then(async (results) => {
    try {
      const json = (await results.json()) as {
        type: "FeatureCollection";
        features: Feature<Point, SearchResult>[];
      };

      return json;
    } catch (e) {
      console.error("[Mapbox]", e);
    }

    return null;
  });
}
